import React from "react"

const Cards = ({ previewData, headerColor, textColor }) => {
  return previewData?.map((x, index) => (
    <div
      key={index}
      style={{
        backgroundImage: `url(${x?.img})`,
        width: "94%",
        height: "100px",
        backgroundSize: "cover",
        margin: "4px 3px",
        backgroundPosition: "center center",
        boxShadow: "inset 0 0 0 100px rgb(0 0 0 / 40%)",
        padding: "5px",
        display: "flex",
      }}
    >
      <div
        style={{
          width: "35px",
          height: "18px",
          backgroundColor: headerColor,
          borderRadius: "10px",
          color: "white",
          textAlign: "center",
          cursor: "pointer",
          minWidth: "fit-content",
          position: "absolute",
          right: "10px",
        }}
      >
        <span style={{ color: textColor }}>Open</span>
      </div>
      <p style={{ alignSelf: "end", color: "white" }}>{x?.name}</p>
    </div>
  ))
}

export default Cards
